import HomeIcon from "@mui/icons-material/Home";

export const getContactDetailsNavList = (contactDetails) => {
  if (!contactDetails) return [];
  return [
    {
      label: "Home",
      value: "home",
      icon: <HomeIcon />,
      route: "/feature-selection/",
    },
    {
      label: "Contact List",
      value: "contactList",
      route: "/contactsview",
    },
    ...(contactDetails && [
      {
        label: contactDetails?.contactName,
        value: "details",
        route: `/contactsview/${contactDetails?.id}/details`,
      },
    ]),
  ];
};

export const getDefaultContactDetails = (data) => ({ ...data });
